export default __webpack_public_path__ + "static/media/buildWealthIcon.62d75454.jpg";